var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXlm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00BEE9;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 150,
    cy: 150,
    r: 150
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.8,76.2l-28.5,14.5l-137.4,70c-0.5-3.5-0.7-7.1-0.7-10.7c0.1-45.2,36.8-81.8,82-81.8 c13.9,0,27.6,3.6,39.8,10.4l16.3-8.3l2.4-1.2C164,36.6,101.5,46.6,69.1,91.3C56.7,108.4,50,128.9,50,150c0,2.5,0.1,5.1,0.3,7.6 c0.6,7.3-3.3,14.2-9.9,17.6l-8.6,4.4V200l25.3-12.9l0,0l8.2-4.2l8.1-4.1l0,0L218.2,105l16.3-8.3l33.7-17.1V59.2L234.8,76.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M268.2,100L81.6,195l-16.3,8.3l-33.5,17.1v20.4l33.3-16.9l28.5-14.5l137.6-70.1c0.5,3.6,0.7,7.2,0.7,10.8 c0,45.2-36.7,81.8-81.9,81.8c-14,0-27.8-3.6-40-10.5l-1,0.5l-17.7,9c44.7,32.4,107.2,22.5,139.7-22.2 c12.4-17.1,19.1-37.6,19.1-58.7c0-2.6-0.1-5.1-0.3-7.7c-0.6-7.3,3.3-14.2,9.9-17.6l8.6-4.4V100z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlm);
export default __webpack_public_path__ + "static/media/XLM.77bee13d53587d1b7a960361a266973d.svg";
export { ForwardRef as ReactComponent };